import React, { useImperativeHandle,  useRef, forwardRef, useState} from "react";
import {RCCRefModalProps } from "react-common-components";
import FCA from "src/components/FCA";
import { IRefComponentFCA } from "src/components/FCA/interface";
import Modal from "src/components/Modal";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { checkSituationOccurrence, IOccurrence, IRefModalFcaAnalysis } from "../interface";

const ModalFcaAnalysis: React.ForwardRefRenderFunction<IRefModalFcaAnalysis> = (_, ref) => {

	const { translate } = useTranslation();
	const { administrator, superUser, checkIfHasSpecificPermission } = useAuth();

	const modalFcaAnalysis = useRef<RCCRefModalProps>(null);
	const fcaRef = useRef<IRefComponentFCA>(null);
	
	const [selectedOccurence, setSelectedOccurence] = useState<IOccurrence>({} as IOccurrence);

	useImperativeHandle(ref, () => ({
		actionButtonFcaAnalysis
	}));

	const actionButtonFcaAnalysis = async (row: IOccurrence) => {
		async function executeOpen(){
			setSelectedOccurence(row);
			modalFcaAnalysis.current?.openModal();
		}
		await executeOpen();
		fcaRef.current?.executeQuery();
	};

	const disabledFCA = () => {
		const statusFinishedCanceledDisapproved = selectedOccurence.ocb001Status === checkSituationOccurrence.CANCELED || selectedOccurence.ocb001Status === checkSituationOccurrence.FINISHED || selectedOccurence.ocb001Status === checkSituationOccurrence.DISAPPROVED;

		if(statusFinishedCanceledDisapproved)
			return true;

		const isAdminOrSuper = administrator || superUser;
		if(isAdminOrSuper)
			return false;
	
		const canCreateUpdate = checkIfHasSpecificPermission("/occurrences/panel", PermissionEnum.CREATE_UPDATE);
		if(!canCreateUpdate)
			return true;

		return false;
	};

	return (
		<>
			{selectedOccurence && (
				<>
					<Modal	
						ref={modalFcaAnalysis}
						header={{
							title: translate("Análises críticas (FCA)"),
							icon: {
								name: "exclamationCircle"
							},
							subtitle:  `${translate("Ocorrência")}: ${selectedOccurence.fullTitle}`
						}}
						footer= {{
							showSaveButton: false,
							buttonLoadingText: translate("Carregando"),
							saveButtonText: translate("Salvar"),
							cancelButtonText: translate("Cancelar")
						}}
						withoutForm
					>
						<FCA 
							ref={fcaRef}
							id={selectedOccurence.ocb001Id}
							tablesRelated={2}
							disabled={disabledFCA()}
						/>
					</Modal>
				</>
			)}
		</>
	);
}
;


export default forwardRef(ModalFcaAnalysis);
